(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-chip-slider')) {
    class CollectionChipSlider extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.scroller = this.querySelector('[data-chip-scroller]');
        this.rows = [...this.querySelectorAll('[data-chip-row]')];
        this.previousButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');

        if (!this.scroller || this.rows.length !== 2 || !this.previousButton || !this.nextButton) return;

        this.initialized = true;
        this.desktopMedia = window.matchMedia('(min-width: 990px)');
        this.handleScroll = this.updateButtons.bind(this);
        this.handleLayoutChange = this.updateLayout.bind(this);
        this.handlePrevious = () => this.scroll(-1);
        this.handleNext = () => this.scroll(1);
        this.handlePointerDown = this.onPointerDown.bind(this);
        this.handlePointerMove = this.onPointerMove.bind(this);
        this.handlePointerUp = this.onPointerUp.bind(this);
        this.handlePointerCancel = this.onPointerCancel.bind(this);
        this.handleClickCapture = this.onClickCapture.bind(this);
        this.handleDragStart = (event) => {
          if (this.desktopMedia.matches) event.preventDefault();
        };

        this.updateLayout();
        this.scroller.addEventListener('scroll', this.handleScroll, { passive: true });
        this.scroller.addEventListener('pointerdown', this.handlePointerDown);
        this.scroller.addEventListener('pointermove', this.handlePointerMove);
        this.scroller.addEventListener('pointerup', this.handlePointerUp);
        this.scroller.addEventListener('pointercancel', this.handlePointerCancel);
        this.scroller.addEventListener('click', this.handleClickCapture, true);
        this.scroller.addEventListener('dragstart', this.handleDragStart);
        this.previousButton.addEventListener('click', this.handlePrevious);
        this.nextButton.addEventListener('click', this.handleNext);
        this.desktopMedia.addEventListener('change', this.handleLayoutChange);

        this.resizeObserver = new ResizeObserver(this.handleScroll);
        this.resizeObserver.observe(this.scroller);
        requestAnimationFrame(this.handleScroll);
      }

      disconnectedCallback() {
        if (!this.initialized) return;

        this.scroller.removeEventListener('scroll', this.handleScroll);
        this.scroller.removeEventListener('pointerdown', this.handlePointerDown);
        this.scroller.removeEventListener('pointermove', this.handlePointerMove);
        this.scroller.removeEventListener('pointerup', this.handlePointerUp);
        this.scroller.removeEventListener('pointercancel', this.handlePointerCancel);
        this.scroller.removeEventListener('click', this.handleClickCapture, true);
        this.scroller.removeEventListener('dragstart', this.handleDragStart);
        this.previousButton.removeEventListener('click', this.handlePrevious);
        this.nextButton.removeEventListener('click', this.handleNext);
        this.desktopMedia.removeEventListener('change', this.handleLayoutChange);
        this.resizeObserver.disconnect();
        this.initialized = false;
      }

      updateLayout() {
        const items = [...this.scroller.querySelectorAll('[data-chip-order]')].sort(
          (firstItem, secondItem) => Number(firstItem.dataset.chipOrder) - Number(secondItem.dataset.chipOrder)
        );

        if (this.desktopMedia.matches) {
          items.forEach((item) => this.rows[0].appendChild(item));
        } else {
          items.forEach((item, index) => this.rows[index % 2].appendChild(item));
        }

        this.scroller.scrollLeft = 0;
        this.scroller.classList.add('is-layout-ready');
        requestAnimationFrame(this.handleScroll);
      }

      scroll(direction) {
        const distance = Math.max(this.scroller.clientWidth * 0.85, 240);
        this.scroller.scrollBy({ left: direction * distance, behavior: 'smooth' });
      }

      onPointerDown(event) {
        if (!this.desktopMedia.matches || event.button !== 0) return;
        if (this.scroller.scrollWidth <= this.scroller.clientWidth + 1) return;

        this.pointerId = event.pointerId;
        this.pointerStartX = event.clientX;
        this.scrollStartX = this.scroller.scrollLeft;
        this.isPointerDown = true;
        this.isDragging = false;
      }

      onPointerMove(event) {
        if (!this.isPointerDown || event.pointerId !== this.pointerId) return;

        // The button was released outside the scroller before a drag started, so no pointerup reached us.
        if ((event.buttons & 1) === 0) {
          this.finishPointerInteraction(event.pointerId);
          return;
        }

        const distance = event.clientX - this.pointerStartX;
        if (!this.isDragging && Math.abs(distance) < 5) return;

        if (!this.isDragging) {
          // Capture only once a drag starts: capturing on pointerdown retargets plain clicks to the scroller,
          // so the chip links never receive them.
          this.scroller.setPointerCapture(event.pointerId);
        }

        this.isDragging = true;
        this.scroller.classList.add('is-dragging');
        event.preventDefault();
        this.scroller.scrollLeft = this.scrollStartX - distance;
      }

      onPointerUp(event) {
        if (!this.isPointerDown || event.pointerId !== this.pointerId) return;

        const dragged = this.isDragging;
        this.finishPointerInteraction(event.pointerId);

        if (dragged) {
          this.suppressClick = true;
          setTimeout(() => {
            this.suppressClick = false;
          });
        }
      }

      onPointerCancel(event) {
        if (!this.isPointerDown || event.pointerId !== this.pointerId) return;
        this.finishPointerInteraction(event.pointerId);
      }

      finishPointerInteraction(pointerId) {
        if (this.scroller.hasPointerCapture(pointerId)) {
          this.scroller.releasePointerCapture(pointerId);
        }

        this.isPointerDown = false;
        this.isDragging = false;
        this.pointerId = null;
        this.scroller.classList.remove('is-dragging');
      }

      onClickCapture(event) {
        if (!this.suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        this.suppressClick = false;
      }

      updateButtons() {
        const maximumScroll = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
        this.scroller.classList.toggle('is-scrollable', maximumScroll > 1);
        this.previousButton.disabled = this.scroller.scrollLeft <= 1;
        this.nextButton.disabled = this.scroller.scrollLeft >= maximumScroll - 1;
      }
    }

    customElements.define('collection-chip-slider', CollectionChipSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
